import { bscTestnetTokens } from '@pancakeswap/tokens'
import { getAddress, zeroAddress } from 'viem'

import { PoolCategory, SerializedPool, VaultKey } from '../../types'

export const livePools: SerializedPool[] = [
  {
    sousId: 0,
    stakingToken: bscTestnetTokens.xcad,
    earningToken: bscTestnetTokens.dxcad,
    lockedAddress: '0x83a32F43bE27721D8c80a50baaf668645d04B0f6',
    contractAddress: '0x47fd6B44059cB0A5d6e196ecfB81c75C610882cD',
    poolCategory: PoolCategory.CORE,
    lockedPoolId: 4,
    vaultKey: VaultKey.CakeVault,
  },
  {
    sousId: 1,
    stakingToken: bscTestnetTokens.xcad,
    earningToken: bscTestnetTokens.dxcad,
    contractAddress: '0x47fd6B44059cB0A5d6e196ecfB81c75C610882cD',
    poolCategory: PoolCategory.CORE,
    vaultKey: VaultKey.CakeFlexibleSideVault,
    isBurnable: false,
  },
].map((p) => ({
  ...p,
  contractAddress: getAddress(p.contractAddress || zeroAddress, 97),
  lockedAddress: p.lockedAddress ? getAddress(p.lockedAddress, 97) : undefined,
  stakingToken: p.stakingToken.serialize,
  earningToken: p.earningToken.serialize,
}))

// known finished pools
export const finishedPools: SerializedPool[] = []

export const pools: SerializedPool[] = [...livePools, ...finishedPools]
